import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../assets/logo.png';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Sinthia & KST Brands', to: '/brands' },
  { label: 'Our Stores', to: '/stores' },
  { label: 'Contact', to: '/contact' },
];

const Logo = () => (
  <Link to="/" className="flex items-center gap-3 group">
    <img
      src={logo}
      alt="KST Spice Corner"
      className="w-14 h-14 md:w-16 md:h-16 rounded-full object-cover shrink-0 ring-2 ring-[#c8a24c]/60 transition-transform duration-300 group-hover:scale-105"
    />
    <div className="leading-tight">
      <div className="font-serif-display text-white text-xl md:text-2xl font-bold tracking-wide">
        KST SPICE CORNER
      </div>
      <div className="text-[10px] md:text-[11px] tracking-[0.2em] text-[#c8a24c]/90 font-medium">
        PREMIUM INDIAN & SRI LANKAN GROCERIES
      </div>
    </div>
  </Link>
);

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0b1f3a]/95 backdrop-blur-md shadow-lg py-2'
          : 'bg-gradient-to-b from-[#0b1f3a] to-[#132a4d]/85 py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`nav-link text-sm font-medium tracking-wide transition-colors duration-300 ${
                location.pathname === item.to
                  ? 'text-[#c8a24c] active'
                  : 'text-white/90 hover:text-[#c8a24c]'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/stores"
            className="inline-flex items-center px-6 py-2.5 rounded-full bg-[#c8a24c] text-[#0b1f3a] text-sm font-semibold tracking-wide hover:bg-[#dcbf74] transition-colors duration-300 shadow-md"
          >
            Visit Marsden Park
          </Link>
        </div>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? 'max-h-[420px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="px-6 py-4 flex flex-col gap-1 bg-[#0b1f3a]">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`py-3 border-b border-white/10 text-base font-medium ${
                location.pathname === item.to ? 'text-[#c8a24c]' : 'text-white/90'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/stores"
            className="mt-4 text-center px-6 py-3 rounded-full bg-[#c8a24c] text-[#0b1f3a] font-semibold"
          >
            Visit Marsden Park
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
